import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class AtticDetail {
		constructor(doc)
		{
		this.label = null;
		this.accessibleForObservationIndicator = null;
		this.visualObservationCompletedIndicator = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.accessibleForObservationIndicator = x.getBooleanElement(doc, "./ns:AccessibleForObservationIndicator");
		this.visualObservationCompletedIndicator = x.getBooleanElement(doc, "./ns:VisualObservationCompletedIndicator");
	 }
}

export class Attic {
		constructor(doc)
		{
		this.label = null;
		this.atticDetail = null;
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:ATTIC_DETAIL");
		if (node !== null)
				this.atticDetail = new AtticDetail(node);
	 }
}

export class InteriorRoomSummary {
		constructor(doc)
		{
		this.label = null;
		this.roomType = null;
		this.roomTypeOtherDescription = null;
		this.totalRoomCount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.roomType = x.getStringElement(doc, "./ns:RoomType");
		this.roomTypeOtherDescription = x.getStringElement(doc, "./ns:RoomTypeOtherDescription");
		this.totalRoomCount = x.getIntegerElement(doc, "./ns:TotalRoomCount");
	 }

	GetRoomSummary() {
		var summary = "";
		summary = this.totalRoomCount + " - ";
		summary += h.descriptionOrOther(this.roomType, this.roomTypeOtherDescription);
		return summary;
	}

}

export class Interior {
		constructor(doc)
		{
		this.label = null;
		this.attic = null;
		this.interiorRoomSummaries = [];
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:ATTIC");
		if (node !== null)
				this.attic = new Attic(node);
		nodes = x.selectNodes(doc, "./ns:INTERIOR_ROOM_SUMMARIES/ns:INTERIOR_ROOM_SUMMARY");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.interiorRoomSummaries.push(new InteriorRoomSummary(xn));
			});
		}
	}

	GetRoomSummaries() {
		var sum = "";
		if (this.interiorRoomSummaries !== null)
		for (var s of this.interiorRoomSummaries)
			sum = h.addWithNewline(sum, s.GetRoomSummary());

		return sum;
	}

}
